import {AuthUser} from "aws-amplify/auth";
import React, {useRef, useState} from "react";
import {useBidData} from "../hooks/useBidData";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {FilterMatchMode} from "primereact/api";
import {jsPDF} from "jspdf";
import xlsx from "xlsx";
import FileSaver from "file-saver";
import moment from "moment/moment";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";

export interface BidHistoryAdminProps {
    user: AuthUser;
}

//GetBidHistory
export const BidHistory: React.FC<BidHistoryAdminProps> = ({user}) => {
    const {bidData} = useBidData({user: user});
    const dt = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    //'purchaseOrderNumber', 'city', 'state'
    const [filters, setFilters] = useState({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderID: {value: null, matchMode: FilterMatchMode.CONTAINS},
        city: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        state: {value: null, matchMode: FilterMatchMode.STARTS_WITH}
    });
    const cols: any[] = [
        {title: "ORDER #", dataKey: "orderID"},
        {title: "CITY", dataKey: "city"},
        {title: "STATE", dataKey: "state"},
        {title: "HOT LOAD", dataKey: "hotLoad"},
        {title: "Tarped", dataKey: "tarpRequired"},
        {title: "MILES", dataKey: "miles"},
        {title: "BOOK NOW RATE", dataKey: "bookNowRate"}
    ];
    const exportPdf = () => {
        const exportColumns = cols;
        const doc: any = new jsPDF("landscape", "px");
        doc.autoTable(exportColumns, bidData);
        doc.save('products.pdf');
    };
    const exportExcel = () => {
        let dataMapped: any[] = bidData.map(i => {
            return {}
        });
        dataMapped.unshift({});
        const worksheet = xlsx.utils.json_to_sheet(dataMapped, {skipHeader: true});
        xlsx.utils.sheet_add_aoa(worksheet, [["ORDER #", "CITY", "STATE", "HOT LOAD", "MILES", "BOOK NOW RATE"]]); //heading: array of arrays
        const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        saveAsExcelFile(excelBuffer, 'products');

    };
    const saveAsExcelFile = (buffer: any, fileName: any) => {

        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);

    };
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        let _filters: any = {...filters};

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const formatMoney = (number: any) => {
        return number.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    };
    const emailTemplate = (rowData: any) => {
        return <><span>{rowData['UserId']}</span></>;
    }

    const createdAtTemplate = (rowData: any) => {
        return <><span>{moment(rowData['BidDateTime']).format("MM/DD/YYYY hh:mm A")}</span></>;
    }
    const updatedAtTemplate = (rowData: any) => {
        return <><span>{moment(rowData['lastAccessed']).format("MM/DD/YYYY")}</span></>;
    }
    const bidAmountTemplate = (rowData: any) => {
        return <>
            <div
                className={"text-right w-full " + rowData["IsBookNow"] ? "text-orange-500" : ""}>{formatMoney(rowData['BidAmount'])}</div>
        </>;

    }
    const orderNumberTemplate = (rowData: any) => {
        return <>
            <span>{rowData['OrdNumber'] ? `O:${rowData['OrdNumber']}` : `PO:${rowData['PurchaseOrderNumber']}`}</span></>;
    }
    const header = (
        <div className="flex gap-2 items-center p-ai-center export-buttons">
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success p-mr-2"
                    data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-warning p-mr-2"
                    data-pr-tooltip="PDF"/>
            <div className={"w-40"}>Bids Count: {bidData.length} </div>
            <div className={"w-full text-right"}>
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search"/>
            </div>
        </div>
    );
    return <div>
        <h1>Bid History</h1>
        <DataTable header={header} ref={dt} value={bidData}
                   filters={filters}
                   globalFilterFields={['UserId', 'OrdNumber', 'PurchaseOrderNumber']}
                   currentPageReportTemplate="{totalRecords} total trucks" paginator rows={10}>
            <Column field="userId" header="Email" sortable filter body={emailTemplate}></Column>
            <Column field="bidAmount" header="Amount" sortable filter body={bidAmountTemplate}></Column>
            <Column field="orderNumber" header="Order / PO" sortable filter
                    body={orderNumberTemplate}></Column>

            <Column field="BidDateTime" header="Created At" sortable filter body={createdAtTemplate}></Column>

        </DataTable>
    </div>
}